import { Grid } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";

const SmGrid = styled(Grid)(({ theme }) => ({
  maxWidth: theme.breakpoints.values.sm,
}));

export default SmGrid;
